export default "__VITE_ASSET__CxDrRK0o__"